import dynamic from 'next/dynamic';
import Head from 'next/head'

const Layout = dynamic(() => import('../components/layout'));
const Klarna = dynamic(() => import('../components/klarna'), {
  ssr: false
})

export default function PayLater() {
  return (
    <Layout>
      <Head>
        <title>Pay Later With Klarna At Soluna London</title>
        <meta
          name="description"
          content="Shop now, pay later with Klarna and Soluna London for all your beauty needs. Call 0333 016 3500"
        />
        <link rel="canonical" href={`https://solunalondon.com/pay-later/`} />
        <link
          rel="alternate"
          hrefLang="en-GB"
          href={`https://solunalondon.com/pay-later/`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://solunalondon.com/pay-later/`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://solunalondon.com/pay-later/`}
        />
      </Head> 
      <h1 className="hidden text-center text-2xl">Shop now, pay later with Klarna.</h1>
      {/* @ts-ignore */}
      <Klarna
        data-key="info-page"
        data-locale="en-GB"
      />
    </Layout>
  )
}